import React from "react";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";

import {
  benefitDiscountTypeOptions,
  benefitStatusOptions,
} from "../../utils/constants/benefits-constants";
import { BenefitDiscountType, BenefitStatus } from "../../models/benefits";
import { DateRangeFilter } from "./DateRangeFilter";

interface PartnerBenefitFiltersProps {
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  status?: BenefitStatus;
  setStatus: React.Dispatch<React.SetStateAction<BenefitStatus | undefined>>;
  discountType?: BenefitDiscountType;
  setDiscountType: React.Dispatch<
    React.SetStateAction<BenefitDiscountType | undefined>
  >;
  vigenciaFrom: Date | null;
  setVigenciaFrom: React.Dispatch<React.SetStateAction<Date | null>>;
  vigenciaTo: Date | null;
  setVigenciaTo: React.Dispatch<React.SetStateAction<Date | null>>;
  onClearAll: () => void;
}

// Filtros del listado de beneficios de un partner (BenefitPartnerDetail): a
// diferencia de BenefitFilters no hay selector de partner (ya está fijo) ni de
// categoría (un Benefit no tiene categoryId propio, solo el partner la tiene).
// En su lugar se filtra por tipo de descuento, que sí varía por beneficio.
export const PartnerBenefitFilters = ({
  title,
  setTitle,
  status,
  setStatus,
  discountType,
  setDiscountType,
  vigenciaFrom,
  setVigenciaFrom,
  vigenciaTo,
  setVigenciaTo,
  onClearAll,
}: PartnerBenefitFiltersProps) => {
  return (
    <div className="grid mt-3 row-gap-3">
      {/* Mismo patrón que EventFilters: sin botón "X" por campo y un único
          "Limpiar filtros". Fila 1: Título · Estado · Tipo de descuento ·
          Vigencia desde. Fila 2: Vigencia hasta + acciones. */}
      <div className="col-12 md:col-3">
        <FloatLabel className="w-full">
          <InputText
            id="partnerBenefitTitle"
            name="partnerBenefitTitle"
            className="w-full"
            onChange={(e) => setTitle(e.currentTarget.value)}
            value={title}
          />
          <label htmlFor="partnerBenefitTitle">Título</label>
        </FloatLabel>
      </div>
      <div className="col-12 md:col-3">
        <FloatLabel className="w-full">
          <Dropdown
            id="partnerBenefitStatus"
            name="partnerBenefitStatus"
            className="w-full"
            onChange={(e: DropdownChangeEvent) => setStatus(e.value ?? undefined)}
            value={status ?? null}
            optionLabel="label"
            optionValue="value"
            options={benefitStatusOptions}
            showClear
          />
          <label htmlFor="partnerBenefitStatus">Estado</label>
        </FloatLabel>
      </div>
      <div className="col-12 md:col-3">
        <FloatLabel className="w-full">
          <Dropdown
            id="partnerBenefitDiscountType"
            name="partnerBenefitDiscountType"
            className="w-full"
            onChange={(e: DropdownChangeEvent) => setDiscountType(e.value ?? undefined)}
            value={discountType ?? null}
            optionLabel="label"
            optionValue="value"
            options={benefitDiscountTypeOptions}
            showClear
          />
          <label htmlFor="partnerBenefitDiscountType">Tipo de descuento</label>
        </FloatLabel>
      </div>
      <DateRangeFilter
        variant="filter"
        dateFrom={vigenciaFrom}
        dateTo={vigenciaTo}
        onDateFromChange={setVigenciaFrom}
        onDateToChange={setVigenciaTo}
        startDateId="partnerBenefitVigenciaFrom"
        endDateId="partnerBenefitVigenciaTo"
        labelFrom="Vigencia desde"
        labelTo="Vigencia hasta"
        columnClassName="col-12 md:col-3"
      />
      <div className="col-12 md:col flex flex-wrap justify-content-end align-items-center gap-2">
        <Button
          type="button"
          label="Limpiar filtros"
          icon="pi pi-filter-slash"
          severity="secondary"
          outlined
          size="small"
          onClick={onClearAll}
        />
      </div>
    </div>
  );
};
